var _rect, _path, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 54.0635,
    height: 54.0635,
    fill: "url(#paint0_linear_567_1570)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.0082 21.63H41.9864V34.281H39.6643V21.63H35.6523V19.5564H46.0082V21.63ZM34.8424 34.281H26.9862V19.5564H34.5311V21.63H29.3083V25.8007H34.1205V27.8644H29.3083V32.219H34.8424V34.281ZM23.9112 34.281H21.3723L14.6878 23.4578C14.5206 23.1885 14.3798 22.9028 14.2674 22.605H14.2087C14.2608 22.921 14.2869 23.595 14.2869 24.6285V34.281H12.043V19.5564H14.7465L21.2077 30.1253C21.4799 30.5618 21.6559 30.8645 21.7341 31.0284H21.7732C21.708 30.6387 21.6754 29.9765 21.6754 29.0467V19.5547H23.9112V34.281ZM9.72901 33.1221C9.72901 33.3043 9.69237 33.4847 9.62118 33.653C9.55 33.8213 9.44566 33.9742 9.31414 34.1029C9.18262 34.2317 9.0265 34.3338 8.8547 34.4033C8.6829 34.4729 8.4988 34.5086 8.31291 34.5084C8.12701 34.5084 7.94294 34.4725 7.77122 34.4027C7.5995 34.333 7.44349 34.2307 7.31212 34.1018C7.18076 33.9729 7.0766 33.8198 7.00562 33.6514C6.93464 33.4831 6.89821 33.3026 6.89844 33.1204C6.89889 32.753 7.04811 32.4008 7.31333 32.1412C7.57855 31.8816 7.93806 31.7357 8.31291 31.7357C8.4988 31.7355 8.6829 31.7712 8.8547 31.8408C9.0265 31.9104 9.18262 32.0125 9.31414 32.1412C9.44566 32.27 9.55 32.4229 9.62118 32.5912C9.69237 32.7595 9.72901 32.9399 9.72901 33.1221V33.1221Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_567_1570",
    x1: 27.0317,
    y1: 0,
    x2: 27.0317,
    y2: 54.0635,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F36F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#922994"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNet);
export default __webpack_public_path__ + "static/media/net.606be2c8b754b8fcdab2c6a1b1a473fe.svg";
export { ForwardRef as ReactComponent };